import React, { useRef, useEffect, useState } from "react";
import "../../App.css";
import html2canvas from "html2canvas";
import "@fortawesome/fontawesome-free/css/all.min.css";
import AWS from "aws-sdk";
import Popup2 from "./Popup2";
import VoteCard from "../sections/Vote_Card";
import ReactDOM from 'react-dom';






const partyFullForm = {
  'ALP': 'Australian Labor Party',
  'LP': 'Liberal Party of Australia',
  'NATS': 'National Party of Australia',
  'AG': 'Australian Greens',
  'PHON': 'Pauline Hanson’s One Nation',
  'KAP': 'Katter’s Australian Party',
  'CA': 'Centre Alliance',
  'UAP': 'United Australia Party',
  'LNP': 'Liberal National Party of Queensland',
  'CLP': 'Country Liberal Party',
  'SFF': 'Shooters, Fishers and Farmers Party',
  'AJP': 'Animal Justice Party',
  'AD': 'Australian Democrats',
  'CDP': 'Christian Democratic Party',
  'DLP': 'Democratic Labour Party',
  'RA': 'Reason Australia',
  'SP': 'Science Party',
  'SPA': 'Secular Party of Australia',
  'SAP': 'Sustainable Australia Party',
  'PPAU': 'Pirate Party Australia',
  'AP': 'Australian Progressives',
  'AC': 'Australian Conservatives',
  'ACR': 'Australian Christians',
  'ACP': 'Australian Cyclists Party',
  'AMEP': 'Australian Motoring Enthusiast Party',
  'ARFP': 'Australian Recreational Fishers Party',
  'ASP': 'Australian Sex Party',
  'ASP': 'Australian Sovereignty Party',
  'ASP': 'Australian Sports Party',
  'AVP': 'Australian Voice Party',
  'AWP': 'Australian Workers Party',
  'AYCC': 'Australian Youth Climate Coalition',
  'BAP': 'Building Australia Party',
  'CEC': 'Citizens Electoral Council of Australia',
  'CCP': 'Climate Change Coalition',
  'CEAA': 'Climate Emergency Action Alliance',
  'CPA': 'Communist Party of Australia',
  'DSP': 'Democratic Socialist Perspective',
  'FFP': 'Family First Party',
  'FP': 'Future Party',
  'HEMP': 'Help End Marijuana Prohibition (HEMP) Party',
  'ICAN': 'Independents for Climate Action Now',
  'LDP': 'Liberal Democratic Party',
  'NCPP': 'Non-Custodial Parents Party (Equal Parenting)',
  'ODD': 'Online Direct Democracy',
  'PLP': 'Progressive Labour Party',
  'REP': 'Renewable Energy Party',
  'RUAP': 'Rise Up Australia Party',
  'SUPA': 'Seniors United Party of Australia',
  'SA': 'Socialist Alliance',
  'SEP': 'Socialist Equality Party',
  'TAP': 'The Arts Party',
  'AMHP': 'The Australian Mental Health Party',
  'TWP': 'The Women’s Party',
  'VEP': 'Voluntary Euthanasia Party',
  'WAP': 'Western Australia Party',
  'IND': 'Independents' ,
  'JLN': 'Jacqui Lambie Network'
};

function Popup3({ onClose, selectedType, userState, phoneNo }) {
  const [showPopup2, setShowPopup2] = useState(false);
  const [showVoteCard, setShowVoteCard] = useState(false);

  const tableRef = useRef(); // For table download
  const popupRef = useRef(); // For entire popup share
  const [individualNames, setIndividualNames] = useState([]);
  const [individualPercentages, setIndividualPercentages] = useState([]);
  const [partyNames, setPartyNames] = useState([]);
  const [partyPercentages, setPartyPercentages] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const [showScreenshot, setShowScreenshot] = useState(false);
  const [showSocialMediaPopup, setShowSocialMediaPopup] = useState(false);

  // Fetch data based on selectedType
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedType === "Federal") {
          const responseLeaderboard = await fetch(
            `/api/leaderboard?phoneNo=${phoneNo}`
          );
          const leaderboardData = await responseLeaderboard.json();
          setIndividualNames(leaderboardData.map((mp) => mp.mp_name));
          setIndividualPercentages(leaderboardData.map((mp) => mp.percentage));

          const responsePartyLeaderboard = await fetch(
            `/api/leaderboard-party?phoneNo=${phoneNo}`
          );
          const partyLeaderboardData = await responsePartyLeaderboard.json();
          setPartyNames(partyLeaderboardData.map((party) => party.party));
          setPartyPercentages(
            partyLeaderboardData.map((party) => party.percentage)
          );
        } else{
          const responseStateLeaderboard = await fetch(
           
        // Fetch state-specific leaderboard data
        `/api/leaderboard/mp?phoneNo=${phoneNo}&state=${userState}`
          );
          const stateLeaderboardData = await responseStateLeaderboard.json();
          setIndividualNames(stateLeaderboardData.map((mp) => mp.mp_name));
          setIndividualPercentages(
            stateLeaderboardData.map((mp) => mp.percentage)
          );

          const responseStatePartyLeaderboard = await fetch(
            `/api/leaderboard-party/state?phoneNo=${phoneNo}&state=${userState}`
          );
          const statePartyLeaderboardData =
            await responseStatePartyLeaderboard.json();
          setPartyNames(statePartyLeaderboardData.map((party) => party.party));
          setPartyPercentages(
            statePartyLeaderboardData.map((party) => party.percentage)
          );
        }
      } catch (error) {
        console.error("Error fetching leaderboard data:", error);
        alert("An error occurred while fetching leaderboard data.");
      }
    };

    fetchData();
  }, [selectedType, userState, phoneNo]);

  // Generate Popup Image using html2canvas
  const generatePopupImage = async () => {
    if (popupRef.current) {
      try {
        // Save the original styles
        const originalStyle = popupRef.current.style.cssText;
  
        // Temporarily remove any height and overflow restrictions
        popupRef.current.style.maxHeight = "none";
        popupRef.current.style.overflow = "visible";
  
        // Ensure the popup is fully visible within the viewport
        const { width, height } = popupRef.current.getBoundingClientRect();
        const options = {
          useCORS: true,
          backgroundColor: "#ffffff",
          width: width, // Match popup's width
          height: height, // Match popup's height
          windowWidth: document.documentElement.clientWidth,
          windowHeight: document.documentElement.clientHeight,
          scrollY: -window.scrollY, // Capture at the current scroll position
        };
  
        // Generate the screenshot
        const canvas = await html2canvas(popupRef.current, options);
  
        // Restore the original styles
        popupRef.current.style.cssText = originalStyle;
  
        // Convert the canvas to a data URL
        const dataUrl = canvas.toDataURL("image/png");
  
        // Copy the generated image to clipboard
        const blob = await new Promise((resolve) =>
          canvas.toBlob(resolve, "image/png")
        );
        await navigator.clipboard.write([
          new ClipboardItem({
            "image/png": blob,
          }),
        ]);
  
        return dataUrl;
      } catch (err) {
        console.error("Error generating screenshot:", err);
        return null;
      }
    }
    return null;
  };
    

  // Handle Download Button
  const handleDownload = async () => {
    const popupImage = await generatePopupImage();
    if (popupImage) {
      const link = document.createElement("a");
      link.download = "leaderboard.png";
      link.href = popupImage;
      link.click();
    } else {
      alert("Failed to download the image.");
    }
  };

  const uploadToBackend = async (imageDataUrl) => {
    const blob = await fetch(imageDataUrl).then((res) => res.blob());
    const formData = new FormData();
    formData.append("media", blob, "leaderboard.png"); // ✅ Change "image" to "media"
  
    const response = await fetch("/api/upload-s3", {
      method: "POST",
      body: formData,
    });
  
    if (!response.ok) {
      throw new Error("Failed to upload image");
    }
  
    const data = await response.json();
    return data.mediaUrl; // ✅ Ensure this is used in the frontend
  };
  
  

  // Handle Share Button
  const handleShareClick = async () => {
    const popupImage = await generatePopupImage();
    if (popupImage) {
      try {
        const s3Url = await uploadToBackend(popupImage);
        setImageUrl(s3Url);
        setShowSocialMediaPopup(true); // Show the sharing popup
      } catch (err) {
        console.error("Error uploading image to backend:", err);
        alert("Failed to upload image for sharing.");
      }
    } else {
      alert("Failed to generate image for sharing.");
    }
  };
  
  // Handle Social Media Share
  const handleSocialMediaShare = (platform) => {
    if (!imageUrl) {
      alert("Image is not ready for sharing.");
      return;
    }
  
    const message = "Check out this leaderboard!";
    const encodedUrl = encodeURIComponent(imageUrl);
  
    switch (platform) {
      case "facebook":
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`, "_blank");
        break;
      case "twitter":
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}&url=${encodedUrl}`, "_blank");
        break;
      case "linkedin":
        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`, "_blank");
        break;
      case "whatsapp":
        window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}%20${encodedUrl}`, "_blank");
        break;
      case "email":
        window.open(
          `mailto:?subject=${encodeURIComponent("Leaderboard Snapshot")}&body=${encodeURIComponent(
            `${message}\n\n${imageUrl}`
          )}`,
          "_blank"
        );
        break;
      default:
        alert("Unsupported platform.");
    }
  
    setShowSocialMediaPopup(false); // Close the popup
  };
  
  

  return showPopup2 ? (
    <Popup2 onClose={() => setShowPopup2(false)} type="Federal" />
  ) : (
    <div
      ref={popupRef}
      className="popup-section3"
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "90%",
        maxWidth: "800px",
        maxHeight: "90vh", // Restrict popup height
        overflowY: "auto", // Enable scrolling for entire popup
        backgroundColor: "#fff",
        borderRadius: "10px",
        padding: "20px",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
        zIndex: 999,
      }}
    >
      {/* Existing Popup3 UI */}
      <h3 style={{ textAlign: "center", marginBottom: "20px" }}>Leaderboard</h3>
  
      <div
        ref={tableRef}
        style={{
          maxHeight: "400px", // Restrict table height to make the whole popup scrollable
          overflowY: "auto", // Allow scrolling inside the table
          border: "1px solid #ddd",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr>
              <th colSpan="2" style={headerCellStyle}>
                Vote by Individual
              </th>
              <th colSpan="2" style={headerCellStyle}>
                Vote by Party
              </th>
            </tr>
            <tr>
              <th style={subHeaderCellStyle}>Name</th>
              <th style={subHeaderCellStyle}>%</th>
              <th style={subHeaderCellStyle}>Name</th>
              <th style={subHeaderCellStyle}>%</th>
            </tr>
          </thead>
          <tbody>
            {individualNames.length === 0 ? (
              <tr>
                <td colSpan="4" style={{ ...tableCellStyle, padding: '20px', color: '#666' }}>
                  Loading...
                </td>
              </tr>
            ) : (
              individualNames.map((name, index) => (
                <tr key={index} style={{ textAlign: "center" }}>
                  <td style={tableCellStyle}>{name}</td>
                  <td style={tableCellStyle}>
                    {individualPercentages[index] !== undefined
                      ? individualPercentages[index].toFixed(2) // Limit to 2 decimal places
                      : ""}
                  </td>
                  <td style={tableCellStyle}>
                    {partyNames[index] || ""}
                    {partyNames[index] && (
                      <i
                        className="fas fa-info-circle"
                        title={
                          partyFullForm[partyNames[index]] ||
                          "No information available"
                        } // Tooltip with full form
                        style={{
                          marginLeft: "8px",
                          color: "black",
                          cursor: "pointer",
                        }}
                      ></i>
                    )}
                  </td>
                  <td style={tableCellStyle}>
                    {partyPercentages[index] !== undefined
                      ? partyPercentages[index].toFixed(2) // Limit to 2 decimal places
                      : ""}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "20px",
        }}
      >
        <button style={buttonStyle} onClick={handleDownload}>
          Download
        </button>
        <button style={buttonStyle} onClick={handleShareClick}>
          Share
        </button>
        <button style={buttonStyle} onClick={() => setShowVoteCard(true)}>
          How to Vote Card
        </button>
        <button style={buttonStyle} onClick={onClose}>
          Exit
        </button>
      </div>
      {showVoteCard && 
        ReactDOM.createPortal(
          <VoteCard onClose={() => setShowVoteCard(false)} />,
          document.body
        )
      }
      {showSocialMediaPopup && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "20px",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
          }}
        >
          <h4 style={{ textAlign: "center", marginBottom: "20px" }}>Share via:</h4>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <i
              className="fa-brands fa-facebook fa-2x"
              style={{ color: "#4267B2", cursor: "pointer" }}
              onClick={() => handleSocialMediaShare("facebook")}
            ></i>
            <i
              className="fa-brands fa-twitter fa-2x"
              style={{ color: "#1DA1F2", cursor: "pointer" }}
              onClick={() => handleSocialMediaShare("twitter")}
            ></i>
            <i
              className="fa-brands fa-whatsapp fa-2x"
              style={{ color: "#25D366", cursor: "pointer" }}
              onClick={() => handleSocialMediaShare("whatsapp")}
            ></i>
            <i
              className="fa-brands fa-linkedin fa-2x"
              style={{ color: "#0A66C2", cursor: "pointer" }}
              onClick={() => handleSocialMediaShare("linkedin")}
            ></i>
            <i
              className="fas fa-envelope fa-2x"
              style={{ color: "#D44638", cursor: "pointer" }}
              onClick={() => handleSocialMediaShare("email")}
            ></i>
          </div>
          <button
            style={{
              marginTop: "20px",
              padding: "10px 20px",
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
            onClick={() => setShowSocialMediaPopup(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
  
}

const headerCellStyle = {
  backgroundColor: "#007bff",
  color: "white",
  padding: "10px",
  textAlign: "center",
  border: "1px solid #ddd",
  fontWeight: "bold",
};

const subHeaderCellStyle = {
  backgroundColor: "#f1f1f1",
  color: "#000",
  padding: "10px",
  textAlign: "center",
  border: "1px solid #ddd",
  fontWeight: "bold",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #ddd",
  textAlign: "center",
};

const buttonStyle = {
  padding: "10px 20px",
  backgroundColor: "#007bff",
  color: "white",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
};

export default Popup3;
